import ShortCutKey from '../../interaction/shortcutkey/index';
import Select from '../../interaction/select/index';

function init(): void {
    // 鼠标左键单选
    ShortCutKey.on({
        keyName: 'mousedown+mouseleft',
        callback: (ev): void => {
            Select.single(ev);
            catchError(ev);
        }
    });

    // 鼠标右键单选
    ShortCutKey.on({
        keyName: 'mousedown+mouseright',
        callback: (ev): void => {
            Select.single(ev);
            catchError(ev);
        }
    });
}

function catchError(ev): void {
    let $target: JQuery<EventTarget> = $(ev.target);

    if ($target.hasClass('shelvesbuild-e-sketchpad__mask')
        || $target.hasClass('shelvesbuild-e-sketchpad__zoom-mask')
        || $target.hasClass('shelvesbuild-e-sketchpad__e-mask')) {
        $target.removeClass('show');
        throw `单选异常: ${$target.prop('outerHTML')}`;
    }
}

export default {
    init
};
